module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./List.js"));
	}, "List");
}